import { AppointmentsPage } from '@app/modules/Appointments/AppointmentsPage'
import { getAppointmentsPath } from '@app/modules/Appointments/paths'

export const routes = [
  {
    path: getAppointmentsPath(),
    component: AppointmentsPage,
    exact: true
  }
]
